// extracted by mini-css-extract-plugin
export default {"text":"ErrorLabel_text__TSIz9"};